import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { lazyRoute } from "./utils";

export function getFrontendDashboardRoutes(): RouteObject[] {
	const frontendDashboardRoutes: RouteObject[] = [
		{ index: true, element: <Navigate to="/zyusetu" replace /> },
		{ path: "dashboard", ...lazyRoute("/pages/dashboard") },
		{
			path: "zyusetu",
			children: [
				{ index: true, ...lazyRoute("/pages/zyusetu/homepage") },
				{ path: ":id", ...lazyRoute("/pages/zyusetu/detail") },
			],
		},
		{ path: "template", ...lazyRoute("/pages/template") },
		{
			path: "company",
			children: [
				{ index: true, ...lazyRoute("/pages/company") },
				{ path: "subscriptions", ...lazyRoute("/pages/company/subscriptions") },
				{ path: "contacts", ...lazyRoute("/pages/company/contacts") },
				{ path: ":id", ...lazyRoute("/pages/company/detail") },
				{ path: ":id/fee-record", ...lazyRoute("/pages/company/fee-record-detail") },
			],
		},
		{
			path: "fee",
			children: [
				{ index: true, ...lazyRoute("/pages/fee") },
				{ path: "operation-log", ...lazyRoute("/pages/fee/operation-log") },
				{ path: "operation-log/:recordId", ...lazyRoute("/pages/fee/operation-log-detail") },
			],
		},
		{
			path: "enterprise",
			children: [
				{ index: true, element: <Navigate to="/enterprise/user" replace /> },
				{ path: "user", ...lazyRoute("/pages/management/system/user") },
				{ path: "user/:id", ...lazyRoute("/pages/management/system/user/detail") },
				{ path: "role", ...lazyRoute("/pages/management/system/role/index") },
				{ path: "role/create", ...lazyRoute("/pages/management/system/role/form") },
				{ path: "role/:uuid/edit", ...lazyRoute("/pages/management/system/role/form") },
			],
		},
		{
			path: "management",
			children: [{ path: "account", ...lazyRoute("/pages/management/user/account") }],
		},
		{
			path: "data-assets",
			children: [
				{ index: true, element: <Navigate to="/data-assets/file-library" replace /> },
				{ path: "file-library", ...lazyRoute("/pages/data-assets/file-library") },
				{ path: "tools-library", ...lazyRoute("/pages/data-assets/tools-library") },
				{ path: "compliance-knowledge-base", ...lazyRoute("/pages/data-assets/compliance-knowledge-base") },
			],
		},
		{
			path: "data-operations",
			children: [
				{ index: true, element: <Navigate to="/data-operations/knowledge-review" replace /> },
				{ path: "knowledge-review", ...lazyRoute("/pages/data-operations/knowledge-review") },
			],
		},
		// removed permission routes
	];
	return frontendDashboardRoutes;
}
